import { render, staticRenderFns } from "./rich_timestamp_tooltip.vue?vue&type=template&id=1aed7747"
import script from "./rich_timestamp_tooltip.vue?vue&type=script&lang=js"
export * from "./rich_timestamp_tooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports